<template>
  <article :class="`post animate_${idx}`" >
    <div class="post__thumbnail">
      <img :src="itm.acf['acf-single-portfolio-gallery'][0].url" :alt="itm.acf['acf-single-portfolio-gallery'][0].alt" data-scroll data-scroll-direction="vertical" data-speed="0.8"/>
    </div>
    <div class="post__data">
      <h3 v-html="itm.title.rendered"></h3>
      <p v-html="itm.acf['acf-single-portfolio-information']"></p>
      <Button
        color="green-dark"
        lineHover="bg-mint-30"
        circleColor="circle-orange"
        text="Learn More"
        :url="itm.link"

      />
    </div>
  </article>
</template>

<script setup>
import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

import Button from '@/components/utility/Button.vue'
import { onBeforeMount } from 'vue'

const props = defineProps(['itm', 'idx', 'totalItem'])

</script>

<style lang="scss" scoped>
  .post{
      @apply flex flex-col md:flex-row justify-between items-center gap-5 md:gap-12 lg:gap-20 mb-16 min-h-[256px] md:min-h-[328px] lg:min-h-[700px];
      &__thumbnail{
        @apply rounded-3xl w-full  md:w-1/2 lg:w-2/3 h-[256px] md:h-[328px] lg:h-[700px] overflow-hidden lg:aspect-auto;
        img{
          @apply w-full h-full object-cover aspect-square ;
        }
      }
      &__data{
        @apply w-full md:w-1/2 lg:w-1/3 px-5 md:px-0;
        h3{
          @apply text-ore_green_dark text-[30px] leading-[30px]  lg:text-[40px] lg:leading-[40px] font-medium md:pb-8 lg:pb-14 lg:max-w-[400px] mb-10 mt-4 md:mb-0 md:mt-0;
        }
        p{
          @apply text-ore_green_dark text-xl font-medium md:pb-8 lg:pb-14 hidden md:block lg:max-w-[437px] ;
        }
      }
    }
</style>
